import React, { useCallback, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import styled from 'styled-components'
import postSaveAdcd from 'src/services/post/postSaveAdcd'
import Loading from 'src/components/layouts/Loading'
import BGCommon from 'src/assets/img/register/bg-common.png'
import { getParameterName } from 'src/services/get/getParameterName'
import { getUtmParams } from 'src/lib/common'

const REACT_APP_LINE_OFFICIAL_ACCOUNT_LINK = process.env.REACT_APP_LINE_OFFICIAL_ACCOUNT_LINK

const UTM_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign']

export const LiffPage = () => {
  const [searchParams] = useSearchParams()
  const adcd = searchParams.get('adcd') || localStorage.getItem('adcd')
  useEffect(() => {
    SaveUtmParams()
    SaveAdcd()
  }, [])

  const SaveUtmParams = useCallback(() => {
    const hasStoredUtm = UTM_PARAMS.some((param) => localStorage.getItem(param))
    if (hasStoredUtm) return
    UTM_PARAMS.forEach((param) => {
      const value = searchParams.get(param)
      if (value) {
        localStorage.setItem(param, value)
      }
    })
  }, [])

  const SaveAdcd = useCallback(() => {
    if (adcd) {
      getParameterName(adcd).then((data) => {
        const parameterName = data.parameter_name
        const sessionParams = searchParams.get(parameterName) || localStorage.getItem(parameterName)
        localStorage.setItem('adcd', adcd)
        const params = {
          access_token: sessionParams,
          adcd: adcd,
          session_params: sessionParams,
          ...getUtmParams()
        }
        postSaveAdcd(params).then(() => {
          // TODO: Temporary set for testing
          setTimeout(() => {
            window.location.href = REACT_APP_LINE_OFFICIAL_ACCOUNT_LINK
          }, adcd === 'fam_te_01' ? 3000 : 0)
        })
      }).catch((e) => console.error(e))
    }
  }, [])

  return (
    <Wrapper>
      <Loading />
    </Wrapper>
  )
}

const Wrapper = styled.div.attrs({
  className: 'sm:w-[400px] w-screen h-screen mx-auto relative bg-center bg-cover bg-no-repeat'
})`
  background-image: url('${BGCommon}');
`
